import { useState } from "react";

const useCBMouserOver = () => {
  const [mouseOverData, setMouseOverData] = useState(false);
  
  const CBMouseHandler = (e) => {
    if (e?.type === "mouseover") {
      setMouseOverData(true);
    } else if (e?.type === "mouseout") {
      setMouseOverData(false);
    }
  };
  
  const resetMouseOver = () => setMouseOverData(false);
  
  return [mouseOverData, CBMouseHandler, resetMouseOver];
};

export default useCBMouserOver;
